import AuthContactPanel from 'components/common/AuthContactPanel';
import React from 'react';

const ActivitiesLandingRightPanel = () => {
  return (
    <>
      <AuthContactPanel />
    </>
  );
};

export default ActivitiesLandingRightPanel;
